import { configureStore } from '@reduxjs/toolkit'

import FormReducer from './reducers/FormReducer'


export default configureStore({
    reducer: {
        form: FormReducer,
    }
})